const cellColors = [
  [
    "#040C12",
    "#081925",
    "#0C2637",
    "#10334A",
    "#14405C",
    "#184C6F",
    "#1C5981",
    "#206694",
    "#2473A6",
    "#2980B9",
    "#3E8CC0",
    "#5399C7",
    "#69A6CE",
    "#7EB2D5",
    "#94BFDC",
    "#A9CCE3",
    "#BED8EA",
    "#D4E5F1",
    "#E9F2F8",
  ],
  [
    "#180308",
    "#300610",
    "#480918",
    "#600C21",
    "#780F29",
    "#901231",
    "#A8153A",
    "#C01842",
    "#D81B4A",
    "#F01F53",
    "#F13564",
    "#F34B75",
    "#F46286",
    "#F67897",
    "#F78FA9",
    "#F9A5BA",
    "#FABBCB",
    "#FCD2DC",
    "#FDE8ED",
  ],
  [
    "#180C03",
    "#301906",
    "#482609",
    "#60330C",
    "#78400F",
    "#904D12",
    "#A85A15",
    "#C06718",
    "#D8741B",
    "#F0811F",
    "#F18D35",
    "#F39A4B",
    "#F4A662",
    "#F6B378",
    "#F7C08F",
    "#F9CCA5",
    "#FAD9BB",
    "#FCE5D2",
    "#FDF2E8",
  ],
  [
    "#0D0118",
    "#1A0231",
    "#27034A",
    "#340463",
    "#41067C",
    "#4E0795",
    "#5B08AE",
    "#6809C7",
    "#750AE0",
    "#820CF9",
    "#8E24F9",
    "#9B3CFA",
    "#A754FA",
    "#B46DFB",
    "#C085FC",
    "#CD9DFC",
    "#D9B6FD",
    "#E6CEFD",
    "#F2E6FE",
  ],
];

export default cellColors;
